<template>
  <header class="site-header" :class="{ 'is-scrolled': scrolled }">
    <nav class="navbar navbar-expand-lg custom-navbar">
      <div class="container">

        <!-- Brand -->
        <router-link class="navbar-brand brand" to="/dashboard">
          <BrandLogo size="md" />
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
          aria-controls="mainNav"
          aria-expanded="false"
          aria-label="باز و بسته کردن منو"
        >
          <i class="bi bi-list"></i>
        </button>

        <div class="collapse navbar-collapse" id="mainNav">
          <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" to="/dashboard">داشبورد</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/mock-exams">آزمون‌های آزمایشی</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/reading-practice">ریدینگ</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/writing-exercises">رایتینگ</router-link>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >اسپیکینگ</a>
              <ul class="dropdown-menu custom-dropdown">
                <li><router-link class="dropdown-item" to="/oral-practice">تمرین شفاهی</router-link></li>
                <li><router-link class="dropdown-item" to="/spoken-language">زبان گفتاری</router-link></li>
                <li><router-link class="dropdown-item" to="/Oral-Mock-Tes">آزمون شفاهی آزمایشی</router-link></li>
              </ul>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/practice-records">سوابق</router-link>
            </li>
          </ul>

          <div class="header-actions">
            <form class="search-form" role="search" @submit.prevent>
              <i class="bi bi-search"></i>
              <input type="search" placeholder="جستجوی آزمون..." aria-label="جستجو" />
            </form>
            <router-link class="btn login-btn" to="/">
              <i class="bi bi-person-circle"></i>
              <span>ورود</span>
            </router-link>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script lang="ts">
import BrandLogo from "@/components/BrandLogo.vue";

export default {
  name: "Header",
  components: { BrandLogo },
  data() {
    return { scrolled: false };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 12;
    },
  },
};
</script>

<style scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 1030;
}

.custom-navbar {
  background: var(--grad-brand);
  padding: 0.85rem 0;
  transition: padding 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.is-scrolled .custom-navbar {
  padding: 0.45rem 0;
  background: rgba(17, 30, 80, 0.85);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(14px);
  box-shadow: 0 10px 30px rgba(8, 15, 45, 0.35);
}

/* Brand */
.brand {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.82);
  font-weight: 500;
  padding: 0.5rem 0.95rem;
  border-radius: 10px;
  position: relative;
  transition: color 0.2s ease, background 0.2s ease;
}
.navbar-nav .nav-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}
.navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-nav .nav-link.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 2px;
  transform: translateX(-50%);
  width: 22px;
  height: 3px;
  border-radius: 999px;
  background: var(--accent-400);
}

/* Dropdown */
.custom-dropdown {
  border: none;
  border-radius: 14px;
  box-shadow: var(--shadow-lg);
  padding: 0.4rem;
  margin-top: 0.6rem;
}
.custom-dropdown .dropdown-item {
  border-radius: 9px;
  padding: 0.55rem 0.9rem;
  font-weight: 500;
  color: var(--ink-700);
}
.custom-dropdown .dropdown-item:hover {
  background: var(--grad-brand-soft);
  color: var(--brand-800);
}

/* Actions */
.header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.search-form {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  padding: 0.45rem 0.95rem;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.search-form:focus-within {
  background: rgba(255, 255, 255, 0.95);
  border-color: #fff;
}
.search-form i {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.95rem;
}
.search-form:focus-within i {
  color: var(--brand-600);
}
.search-form input {
  border: none;
  background: transparent;
  outline: none;
  color: #fff;
  width: 140px;
  font-size: 0.9rem;
}
.search-form input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.search-form:focus-within input {
  color: var(--ink-900);
}
.search-form:focus-within input::placeholder {
  color: var(--ink-500);
}

.login-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  background: #fff;
  color: var(--brand-800);
  font-weight: 700;
  border-radius: 999px;
  padding: 0.5rem 1.25rem;
  white-space: nowrap;
  box-shadow: 0 8px 18px rgba(8, 15, 45, 0.25);
  transition: transform 0.25s ease, box-shadow 0.25s ease, color 0.25s ease;
}
.login-btn:hover {
  color: var(--brand-700);
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(8, 15, 45, 0.32);
}

/* Toggler */
.navbar-toggler {
  border: none;
  color: #fff;
  font-size: 1.6rem;
  padding: 0.1rem 0.4rem;
}
.navbar-toggler:focus {
  box-shadow: none;
}

@media (max-width: 991.98px) {
  .navbar-collapse {
    margin-top: 0.75rem;
    padding: 1rem;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 16px;
  }
  .header-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 0.6rem;
    margin-top: 0.5rem;
  }
  .search-form {
    width: 100%;
  }
  .search-form input {
    width: 100%;
  }
  .login-btn {
    justify-content: center;
  }
  .navbar-nav .nav-link.active::after {
    display: none;
  }
}
</style>
